<template>
  <div class="fixed-left">
    <div class="item" :title="item.title" v-for="item in list" :key="item.id">
      <a :href="item.url" target="_blank">
        <img :src="item.pc_image | baseImg" class="img" />
      </a>
      <span class="close" @click="onClose">
        <img :src="closeImage" class="img-close" />
      </span>
    </div>
  </div>
</template>

<script>
import { getPcIndex } from "@/apis/api";
export default {
  data() {
    return {
      closeImage: require("@/assets/images/guanbi.png"),
      list: [],
    };
  },
  created() {
    this.getPcIndex();
  },
  methods: {
    async getPcIndex() {
      const { data } = await getPcIndex();
      this.list = data || [];
    },
    onClose(e) {
      e.currentTarget.parentElement.style.display = "none";
    },
  },
};
</script>

<style lang="scss" scoped>
.fixed-left {
  position: fixed;
  left: 0;
  top: calc(100vh - 530px);
  z-index: 99;
  animation-name: myanimate;
  animation-duration: 30s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  // animation-direction: alternate;

  .item {
    position: relative;
    margin-bottom: 12px;

    .img {
      object-fit: cover;
    }

    .close {
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }

  }
}

.fixed-left:hover {
  animation-play-state: paused;
  /* 鼠标移入时暂停动画 */
}

/* 鼠标移出时重新启动动画 */
.fixed-left:not(:hover) {
  animation-play-state: running;
}


@keyframes myanimate {
  0% {
    left: 0;
    top: 50%;
  }

  25% {
    left: calc(50% - 100px);
    top: 90vh;
  }

  50% {
    left: 90%;
    top: calc(100vh - 530px);
  }

  75% {
    left: calc(50% - 100px);
    top: 0;
  }

  100% {
    left: 0;
    top: 50%;
  }
}
</style>
